import React, { useState } from 'react';
import { Button, Modal, Stack, Group, Text } from '@mantine/core';
import { IconSquarePlus, IconBrandApple, IconBrandAndroid } from '@tabler/icons-react';

// "Get the app" buttons, shown to everyone side by side like app badges on
// other sites. Android: the APK (nginx redirects /wowcontent.apk to DO
// Spaces). iOS: no app yet, so the button explains that and guides to
// Safari's Share -> Add to Home Screen.

const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';

// The iOS share glyph: a square open at the top with an arrow up.
const ShareIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <path d="M8 9H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-2" />
    <path d="M12 15V3" />
    <path d="M8.5 6.5 12 3l3.5 3.5" />
  </svg>
);

const Step = ({ n, children }) => (
  <Group gap="sm" wrap="nowrap" align="flex-start">
    <Text fw={700} c="blue" style={{ minWidth: 18 }}>{n}</Text>
    <Text size="sm" component="div" style={{ flex: 1 }}>{children}</Text>
  </Group>
);

const IOSGuide = ({ ru, opened, onClose }) => {
  const chrome = /CriOS/.test(ua);
  const firefox = /FxiOS/.test(ua);
  return (
    <Modal opened={opened} onClose={onClose} centered radius="lg"
      title={<Text fw={600}>{ru ? 'Приложение для iOS' : 'iOS app'}</Text>}>
      <Stack gap="md">
        <Text size="sm">
          {ru
            ? 'Приложение для iOS ещё не готово. Чтобы пользоваться сайтом как приложением, добавьте его на экран «Домой»:'
            : 'The iOS app isn’t ready yet. For an app-like experience, add the site to your Home Screen:'}
        </Text>
        {chrome ? (
          <Step n={1}>
            {ru ? 'Нажмите «Поделиться» справа в адресной строке вверху ' : 'Tap Share at the right of the address bar at the top '}
            <ShareIcon />
          </Step>
        ) : firefox ? (
          <Step n={1}>
            {ru ? 'Нажмите «•••» под адресной строкой, затем «Поделиться» ' : 'Tap “•••” below the address bar, then Share '}
            <ShareIcon />
          </Step>
        ) : (
          <Step n={1}>
            {ru ? 'Нажмите «•••» справа от адресной строки, затем «Поделиться» ' : 'Tap “•••” next to the address bar, then Share '}
            <ShareIcon />
            <Text size="xs" c="dimmed" mt={4}>
              {ru ? 'На старых версиях iOS — сразу ' : 'On older iOS versions, tap '}
              <ShareIcon size={16} />
              {ru ? ' внизу экрана.' : ' at the bottom of the screen.'}
            </Text>
          </Step>
        )}
        <Step n={2}>
          {ru ? 'Пролистайте вниз и выберите «На экран „Домой“» ' : 'Scroll down and choose “Add to Home Screen” '}
          <IconSquarePlus size={20} style={{ display: 'inline-block', verticalAlign: 'middle' }} />
        </Step>
        <Step n={3}>{ru ? 'Нажмите «Добавить».' : 'Tap “Add”.'}</Step>
        <Button onClick={onClose} variant="light" mt="xs">{ru ? 'Понятно' : 'Got it'}</Button>
      </Stack>
    </Modal>
  );
};

const InstallAppButton = ({ ru, mt = 'xl' }) => {
  const [guideOpen, setGuideOpen] = useState(false);
  return (
    <Group gap="xs" justify="center" mt={mt}>
      <Button component="a" href="/wowcontent.apk" download variant="light" size="xs"
        leftSection={<IconBrandAndroid size={16} />}>
        {ru ? 'Приложение для Android' : 'Android app'}
      </Button>
      <Button variant="light" size="xs" onClick={() => setGuideOpen(true)}
        leftSection={<IconBrandApple size={16} />}>
        {ru ? 'Приложение для iOS' : 'iOS app'}
      </Button>
      <IOSGuide ru={ru} opened={guideOpen} onClose={() => setGuideOpen(false)} />
    </Group>
  );
};

export default InstallAppButton;
